import { render, staticRenderFns } from "./nxNewLoadMore.vue?vue&type=template&id=038bc976&scoped=true&"
import script from "./nxNewLoadMore.vue?vue&type=script&lang=js&"
export * from "./nxNewLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./nxNewLoadMore.vue?vue&type=style&index=0&id=038bc976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038bc976",
  null
  
)

export default component.exports